import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Card, Button, Row, Col } from "react-bootstrap";
import ContentEditor from "../../../../components/ContentEditor";
import api from "../../../../services/api";
import { toast } from "react-toastify";
import "../../../../styles.css";
export default function FormPages() {
  const navigate = useNavigate();
  const { pageId } = useParams();

  const [pageIdState, setPageIdState] = useState(pageId || null);
  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");
  // Função para gerar slug do título
  function slugify(str) {
    return (
      str
        .normalize("NFD") // separa acentos
        // eslint-disable-next-line no-control-regex
        .replace(/[\u0000-\u001F\u007F]/g, "") // remove caracteres de controle (regex padrão)
        .replace(/[\u0300-\u036f]/g, "") // remove marcas de acentuação
        .replace(/[^a-zA-Z0-9\s-]/g, "") // remove caracteres especiais
        .trim()
        .replace(/\s+/g, "-") // troca espaços por traço
        .toLowerCase()
    );
  }
  const [content, setContent] = useState("");
  const [online, setOnline] = useState(true);
  const [displayOnSite, setDisplayOnSite] = useState(true);
  const [loading, setLoading] = useState(false);
  async function saveContent(content) {
    setContent(content);

    await handleSave(content);
  }
  async function handleSave(proContent = null) {
    setLoading(true);

    const text = proContent
      ? JSON.stringify(proContent)
      : JSON.stringify(content);
    const bodyFormData = new FormData();
    if (pageIdState) {
      bodyFormData.append("page[id]", pageIdState);
    }
    bodyFormData.append("page[title]", title);
    bodyFormData.append("page[slug]", url);
    bodyFormData.append("page[text]", text);
    bodyFormData.append("page[online]", online ? 1 : 0);
    bodyFormData.append("page[display_site]", displayOnSite ? 1 : 0);

    api
      .post("/pages/save", bodyFormData)
      .then((ret) => {
        setLoading(false);
        if (ret.data.id) {
          toast.success("Page saved successfully");
          setPageIdState(ret.data.id);
          navigate("/cms/pages/" + ret.data.id, { replace: true });
        } else {
          toast.error("Error saving page");
          console.log(ret.data);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error saving page");
        console.log(error);
      });
  }

  // Atualiza o URL automaticamente quando o título muda, se o usuário não editou manualmente
  useEffect(() => {
    setUrl(`${slugify(title)}`);
  }, [title]);

  useEffect(() => {
    if (pageIdState) {
      setLoading(true);
      api
        .get("/pages/get/id/" + pageIdState)
        .then((ret) => {
          console.log(ret.data);
          setTitle(ret.data.title);
          setUrl(ret.data.slug);
          setContent(JSON.parse(ret.data.text));
          setOnline(ret.data.online);
          setDisplayOnSite(ret.data.display_site);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } else {
      setTitle("");
      setUrl("");
      setContent("");
      setOnline(true);
      setDisplayOnSite(true);
    }
  }, [pageIdState]);
  useEffect(() => {
    console.log("pageId", pageId);
    if (pageId) {
      setPageIdState(pageId);
    } else {
      setPageIdState(null);
    }
  }, [pageId]);

  return (
    <Card className="mt-4">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <Button
          variant="outline-primary"
          size="sm"
          onClick={() => navigate("/cms/pages")}
        >
          Back
        </Button>
        <Card.Title className="fw-bold mb-0">
          {pageIdState ? "Edit Page" : "New Page"}
        </Card.Title>
        <div className="d-flex gap-2">
          {pageIdState && (
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => navigate("/cms/pages/new", { replace: true })}
            >
              New Page
            </Button>
          )}
          <Button
            disabled={loading}
            variant="outline-primary"
            size="sm"
            onClick={() => handleSave()}
          >
            {loading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Card.Header>
      <Card.Body>
        <Form>
          <Form.Group className="py-2" controlId="formBasicTitle">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="py-2" controlId="formBasicUrl">
            <Form.Label>Slug</Form.Label>
            <Form.Control
              readOnly
              type="text"
              placeholder="Enter url"
              value={url}
            />
          </Form.Group>
          <Row className="py-2">
            <Col>
              <Form.Group controlId="formBasicOnline">
                <Form.Label>Display App</Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={online}
                  onChange={(e) => setOnline(e.target.checked)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="formBasicVisible">
                <Form.Label>Display on site</Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={displayOnSite}
                  onChange={(e) => setDisplayOnSite(e.target.checked)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
        <hr />
        <Row>
          <Col>
            <ContentEditor
              title={title}
              content={content}
              setContent={saveContent}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
